import {connect} from 'react-redux';

import {createSelector, makeMapStateToProps} from '../../srcCommon/helpers/reselectHelpers';
import {makeGetAppPanel} from '../store/panels/app/appPanelSelectors';
import {AppPanelId} from '../store/panels/panelStateBase';
import {AppContent} from './appContent';

/*
 * Props.
 */

interface AppRoutesContainerProps {
  panelId: AppPanelId;
}

/*
 * Selectors.
 */

const getAppPanelContentType = createSelector([makeGetAppPanel()], (appPanel) => appPanel.contentType);

/*
 * Redux.
 */

const mapStateToProps = makeMapStateToProps<AppRoutesContainerProps>()(() => ({
  contentType: getAppPanelContentType,
}));

export const AppContentContainer = connect(mapStateToProps)(AppContent);
